import {placeholderTypes} from "../../Types/Placeholder";
const placeholders =  [
    {
        replacementKey: 'Resources', values:[ ],
        type:placeholderTypes.RESOURCES
    },
    {
        replacementKey: 'ActionReminders', values:
            [
                { id: 1, isActive: true, field: 'Supplier', display: '$SUPPLIER_NAME RFI/TQ awaiting Reply' },
                { id: 2, isActive: true, field: 'PM', display: '$PM_NAME RFI/TQ awaiting Reply' },
            ],
        type:placeholderTypes.ACTION_REMINDERS
    },
    {
        replacementKey: 'UnifiedClauses', values:
            [
                { id: 1, wfid: 34, isActive: true, field: '', display: '$WF_34_NOTIFICATION_NAME Example Clause', },
                { id: 2, wfid: 80, isActive: true, field: '', display: '$WF_80_NOTIFICATION_NAME Example Clause', }
            ],
        skipDefaultLoadingIfMissing: true,
        allowCustomReplyPeriods: true,
        allowConfigureReplyParty: true,
        type: placeholderTypes.UNIFIED_CLAUSES
    },
];
export default placeholders;